// export const SERVER_URL = 'https://lv-test.lvfreshglobal.com' // 测试环境
export const SERVER_URL = 'https://www.lvfreshest.com'  // 生产环境（新）
// export const SERVER_URL = 'https://www.lvfreshglobal.com' // 生产环境（旧）